import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import { addSupplierApi } from "../../../../../Services/SupplierService/SupplierService";
import { comboboxOption } from "../../../constants";
import { addCategoryApi } from "../../../../../Services/categoryService/CategoryService";
import "./Combobox.css";
interface ComboboxProps {
  disabled?: boolean;
  name?: string;
  label?: string;
  value?: string;
  options: comboboxOption[];
  iserror?: boolean;
  errorMessage?: string | undefined | string[];
  onChange?: (value: string, option: comboboxOption | null) => void;
  allowAddNew?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  addNewType?: "supplier" | "category";
  renderOption?: (option: comboboxOption) => React.ReactNode;
}

export const Combobox = ({
  name,
  label = "Combobox",
  disabled = false,
  iserror,
  errorMessage,
  value = "",
  options,
  onChange,
  allowAddNew = false,
  onBlur,
  addNewType,
  renderOption,
}: ComboboxProps) => {
  const [inputValue, setInputValue] = useState(value);
  const [showDropdown, setShowDropdown] = useState(false);
  // const [localOptions, setLocalOptions] = useState<string[]>(options);
  const [localOptions, setLocalOptions] = useState<comboboxOption[]>([]); // [{ a:2, b:3 }]
  const wrapperRef = useRef<HTMLDivElement>(null);

  // Sync options from parent
  useEffect(() => {
    setLocalOptions(options);
  }, [options]);
  console.log("Combobox options:", options);
  // Sync value from parent/API
  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  // Close dropdown outside click
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = localOptions.filter((opt) =>
    opt.optionName.toLowerCase().includes(inputValue.toLowerCase()),
  );

  /**
  const getOptionLabel = (option: string | Supplier) =>
  typeof option === "string"
    ? option
    : option.name;
   */
  const isNewValue =
    inputValue.trim() !== "" &&
    !localOptions.some(
      (opt) => opt.optionName.toLowerCase() === inputValue.toLowerCase(),
    );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;

    setInputValue(val);
    setShowDropdown(true);

    onChange?.(val, null);
  };

  const handleSelect = async (val: comboboxOption, isNew = false) => {
    setInputValue(val.optionName);
    setShowDropdown(false);

    if (allowAddNew && isNew && val.optionId === null) {
      try {
        let { optionId, optionName } = { optionId: null, optionName: val.optionName };

        if (addNewType === "supplier") {
          ({ optionId, optionName } = await addSupplierApi([val.optionName]));
        } else if (addNewType === "category") {
          ({ optionId, optionName } = await addCategoryApi([val.optionName]));
        }
        // Add immediately to dropdown
        setLocalOptions((prev) => [...prev, val]);

        console.log("New supplier added:", val);
      } catch (error) {
        console.error("Failed to add supplier:", error);
      }
    }
    onChange?.(val.optionName, val);
  };

  return (
    <div className="combobox-container" ref={wrapperRef}>
      <div className="combobox-label">{label}</div>
      <div className="combobox-control">
        <div className="combobox-input-wrapper">
          <input
            className="combobox-input"
            placeholder="Select or type to search"
            name={name}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setShowDropdown(true)}
            onBlur={onBlur}
            disabled={disabled}
          />
          <button
            type="button"
            className="combobox-arrow-btn"
            onClick={() => setShowDropdown((prev) => !prev)}
            disabled={disabled}
          >
            <FiChevronDown />
          </button>
        </div>

        {showDropdown && (
          <div className="combobox-dropdown">
            {filteredOptions.map((option, index) => (
              <div
                key={index}
                className="combobox-option"
                onClick={() => handleSelect(option)}
              >
                {renderOption ? renderOption(option) : option.optionName}
              </div>
            ))}

            {allowAddNew && isNewValue && (
              <div
                className="combobox-option combobox-option--add"
                onClick={() =>
                  handleSelect(
                    { optionId: null, optionName: inputValue },
                    true,
                  )
                }
              >
                Add + "{inputValue}"
              </div>
            )}

            {filteredOptions.length === 0 && !isNewValue && (
              <div className="combobox-empty">No options found</div>
            )}
          </div>
        )}

        {iserror && errorMessage && (
          <p className="error-message">{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

// export const Combobox = ({
//   name,
//   label = "Combobox",
//   disabled = false,
//   iserror,
//   errorMessage,
//   value = "",
//   options,
//   onChange,
//   allowAddNew = false,
//   onBlur,
// }: ComboboxProps) => {
//   const [inputValue, setInputValue] = useState(value);
//   const [showDropdown, setShowDropdown] = useState(false);
//   // const [localOptions, setLocalOptions] = useState<string[]>(options);
//   const [localOptions, setLocalOptions] = useState<string[] | SupplierList>([]);
//   const wrapperRef = useRef<HTMLDivElement>(null);

//   // Sync options from parent
//   useEffect(() => {
//     setLocalOptions(options);
//   }, [options]);
//   console.log("Combobox options:", options);
//   // Sync value from parent/API
//   useEffect(() => {
//     setInputValue(value || "");
//   }, [value]);

//   // Close dropdown outside click
//   useEffect(() => {
//     const handleClickOutside = (event: any) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const filteredOptions = localOptions.filter((opt) =>
//     opt.toLowerCase().includes(inputValue.toLowerCase()),
//   );

//   const isNewValue =
//     inputValue.trim() !== "" &&
//     !localOptions.some((opt) => opt.toLowerCase() === inputValue.toLowerCase());

//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const val = e.target.value;

//     setInputValue(val);
//     setShowDropdown(true);

//     onChange?.(val);
//   };

//   const handleSelect = async (val: string, isNew = false) => {
//     setInputValue(val);
//     setShowDropdown(false);
//     onChange?.(val);

//     if (allowAddNew && isNew) {
//       try {
//         await addSupplierApi([val]);

//         // Add immediately to dropdown
//         setLocalOptions((prev) => [...prev, val]);

//         console.log("New supplier added:", val);
//       } catch (error) {
//         console.error("Failed to add supplier:", error);
//       }
//     }
//   };

//   return (
//     <div
//       ref={wrapperRef}
//       style={{
//         width: "100%",
//         background: "#cfd0f5",
//         justifyContent: "space-between",
//         position: "relative",
//         display: "flex",
//         alignItems: "center",
//         padding: " 1px 5px 1px 5px",
//       }}
//     >
//       <table style={{ width: "100%", background: "#cfd0f5" }}>
//         <tbody>
//           <tr>
//             {/* LABEL */}
//             <td style={{ width: "29.5%", height: "auto", fontWeight: 400 }}>
//               {label}
//             </td>

//             {/* INPUT */}
//             <td style={{ position: "relative", width: "75%", height: "auto" }}>
//               <input
//                 style={{
//                   width: "100%",
//                   padding: "8px",
//                   border: "1px solid #9e9e9e",
//                   borderRadius: 4,
//                 }}
//                 placeholder="Select or type to search"
//                 name={name}
//                 value={inputValue}
//                 onChange={handleInputChange}
//                 onFocus={() => setShowDropdown(true)}
//                 onBlur={onBlur}
//                 disabled={disabled}
//               />

//               {/* DROPDOWN */}
//               {showDropdown && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     width: "100%",
//                     background: "#fff",
//                     border: "1px solid #9e9e9e",
//                     maxHeight: 200,
//                     overflowY: "auto",
//                     zIndex: 1000,
//                     marginTop: 4,
//                   }}
//                 >
//                   {filteredOptions.map((option, index) => (
//                     <div
//                       key={index}
//                       onClick={() => handleSelect(option)}
//                       style={{ padding: "8px", cursor: "pointer" }}
//                       onMouseEnter={(e) =>
//                         (e.currentTarget.style.background = "#f5f5f5")
//                       }
//                       onMouseLeave={(e) =>
//                         (e.currentTarget.style.background = "white")
//                       }
//                     >
//                       {option}
//                     </div>
//                   ))}

//                   {allowAddNew && isNewValue && (
//                     <div
//                       onClick={() => handleSelect(inputValue, true)}
//                       style={{
//                         padding: "8px",
//                         cursor: "pointer",
//                         color: "var(--color-text-link)",
//                         fontWeight: 500,
//                       }}
//                     >
//                       Add + "{inputValue}"
//                     </div>
//                   )}

//                   {filteredOptions.length === 0 && !isNewValue && (
//                     <div style={{ padding: "8px", color: "#999" }}>
//                       No options found
//                     </div>
//                   )}
//                 </div>
//               )}

//               {iserror && errorMessage && (
//                 <p style={{ color: "red", marginTop: 4 }}>{errorMessage}</p>
//               )}
//             </td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };
